// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__77STG","footerTypo":"Footer_footerTypo__2loYm"};